export const NET_FUNNEL_COUPON_DOWNLOAD_ERROR_MAP = Object.freeze({
  IP_BLOCK: '반복 요청으로 쿠폰받기를 진행할 수 없습니다.',
  CLOSE: '쿠폰받기 대기를 취소하셨습니다.',
})

export const NET_FUNNEL_COUPON_ENTRY_ERROR_MAP = Object.freeze({
  IP_BLOCK: '반복적인 요청으로 접근이 제한되었습니다.',
  CLOSE: '대기가 취소되었습니다.',
})
